import { ArrowRightOutlined } from '@ant-design/icons';
import { Display } from '@/components/Display/Display';
import s from './style.module.scss';
import { useEffect, useState } from 'react';
import ChatFile from './components/ChatFile';
import { fileTypeMap } from '@/utils/Page/constant';
import React from 'react';
import MobileImage from './components/Image';
import WebImgage from './components/Image';
import { Image } from 'antd';
import PreviewImg from '@/components/Web/PreviewImg';
const ChatFiles = (props) => {
    const { fileList } = props;
    const [isSingelImg, setIsSingelImg] = useState(false);
    useEffect(() => {
        if (fileList.length === 1 && fileList[0].type === fileTypeMap.img) {
            setIsSingelImg(true);
        } else {
            setIsSingelImg(false);
        }
    }, [fileList]);
    return (
        <>
            <Display show={isSingelImg}>
                <div className={s['single-img-type-wrap']}>
                    <PreviewImg src={fileList?.[0]?.file_url}></PreviewImg>
                    {/* <Image src={fileList?.[0]?.file_url} preview={fileList?.[0]?.file_url}></Image> */}
                </div>
            </Display>
            <Display show={!isSingelImg}>
                <div className={s['files-wrap']} data-from={'chat'}>
                    <div className={s['file-list-wrap']}>
                        {fileList.map((ele, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <ChatFile index={index} file={ele}></ChatFile>
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>
            </Display>
        </>
    );
};
export default ChatFiles;
